import React, { Component, Fragment } from 'react';

import { CloseModal } from 'modules/common/styles/main';
import Icon from './Icon';

import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

const propTypes = {
  title: PropTypes.string.isRequired,
  trigger: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  backdrop: PropTypes.bool,
  ignoreTrans: PropTypes.bool,
  dialogClassName: PropTypes.string,
  showHide: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  openMapTeamModal: PropTypes.func.isRequired,
  closeMapTeamModal: PropTypes.func.isRequired,
};

// const childContextTypes = {
//   closeModal: PropTypes.func.isRequired
// };

const contextTypes = {
  __: PropTypes.func
};

class ModalTriggerUI extends Component {
  constructor(props) {
    super(props);

    // console.log("Modal Trigger", this.props.showHide);
    this.state = { isOpen: false };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  getChildContext() {
    return { closeModal: this.closeModal };
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  closeModal() {
    this.setState({ isOpen: false });
  }

  renderHeader = () => {
    const { __ } = this.context;
    if (this.props.hideHeader) {
      return (
        <CloseModal onClick={this.props.closeModal}>
          <Icon icon="times" />
        </CloseModal>
      );
    }

    const { title, ignoreTrans, paddingContent } = this.props;
    return (
      // <Modal.Header closeButton>
      //   <Modal.Title>{ignoreTrans ? title : __(title)}</Modal.Title>
      // </Modal.Header>
      <Modal.Header>
        <Modal.Title>{ignoreTrans ? title : __(title)}</Modal.Title>
        <span onClick={() => this.props.closeModal()} style={{ cursor: "pointer", color: '#010101', fontSize: '25px' }} className='material-symbols-outlined'>cancel</span>
      </Modal.Header>
    );
  };

  render() {
    const {
      title,
      trigger,
      children,
      size,
      backdrop,
      ignoreTrans,
      dialogClassName,
      closeModal,
      openModal,
    } = this.props;
    const { __ } = this.context;

    // add onclick event to the trigger component
    const triggerComponent = React.cloneElement(trigger, {
      onClick: () => this.props.openModal()
    });

    return (
      <Fragment>
        {triggerComponent}

        <Modal
          dialogClassName={dialogClassName}
          bsSize={size}
          show={this.props.showHide}
          onHide={() => this.props.closeModal()}
          backdrop='true'
          className={dialogClassName}
        >
          {this.renderHeader()}
          <Modal.Body>{children}</Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

ModalTriggerUI.propTypes = propTypes;
ModalTriggerUI.contextTypes = contextTypes;
// ModalTriggerUI.childContextTypes = childContextTypes;

export default ModalTriggerUI;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ModalTriggerUI.js